import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { useLang } from "@/context/LangContext";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { toast } from "sonner";

export default function Organization() {
  const { t } = useLang();
  const [form, setForm] = useState({
    name: "",
    reporting_year: new Date().getFullYear(),
    country: "Global",
    industry: "",
    base_year: "",
    description: "",
  });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    api.get("/organization").then((r) => {
      if (r.data) {
        setForm({
          name: r.data.name || "",
          reporting_year: r.data.reporting_year || new Date().getFullYear(),
          country: r.data.country || "Global",
          industry: r.data.industry || "",
          base_year: r.data.base_year || "",
          description: r.data.description || "",
        });
      }
    });
  }, []);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/organization", {
        ...form,
        reporting_year: parseInt(form.reporting_year),
        base_year: form.base_year ? parseInt(form.base_year) : null,
      });
      toast.success(t("orgSaved"));
    } catch (err) {
      toast.error(err.response?.data?.detail || "Error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-2xl space-y-6">
      <div>
        <div className="text-xs uppercase tracking-widest text-muted-foreground font-mono-data">Reporting entity</div>
        <h1 className="font-display text-3xl font-semibold mt-1">{t("settings")}</h1>
      </div>

      <Card>
        <CardHeader>
          <CardTitle className="font-display text-lg">{t("organization")}</CardTitle>
        </CardHeader>
        <CardContent>
          <form onSubmit={submit} className="space-y-4" data-testid="org-form">
            <div className="space-y-2">
              <Label>{t("orgName")}</Label>
              <Input required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} data-testid="org-name" />
            </div>
            <div className="grid grid-cols-2 gap-4">
              <div className="space-y-2">
                <Label>{t("reportingYear")}</Label>
                <Input type="number" required value={form.reporting_year} onChange={(e) => setForm({ ...form, reporting_year: e.target.value })} data-testid="org-year" />
              </div>
              <div className="space-y-2">
                <Label>{t("baseYear")}</Label>
                <Input type="number" value={form.base_year} onChange={(e) => setForm({ ...form, base_year: e.target.value })} data-testid="org-base" />
              </div>
            </div>
            <div className="grid grid-cols-2 gap-4">
              <div className="space-y-2">
                <Label>{t("country")}</Label>
                <Input value={form.country} onChange={(e) => setForm({ ...form, country: e.target.value })} data-testid="org-country" />
              </div>
              <div className="space-y-2">
                <Label>{t("industry")}</Label>
                <Input value={form.industry} onChange={(e) => setForm({ ...form, industry: e.target.value })} data-testid="org-industry" />
              </div>
            </div>
            <div className="space-y-2">
              <Label>{t("orgDescription")}</Label>
              <Textarea value={form.description} onChange={(e) => setForm({ ...form, description: e.target.value })} data-testid="org-desc" />
            </div>
            <Button type="submit" disabled={loading} data-testid="org-save">{loading ? "…" : t("saveOrg")}</Button>
          </form>
        </CardContent>
      </Card>
    </div>
  );
}
